module.exports = __webpack_public_path__ + "img/slider_products.17469ab3.jpg";